import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import FbCircularProgress from '../FbCircularProgress';
import SimpleModal from '../Modal';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  uploadingModal: {
    maxWidth: 450,
    textAlign: 'center',
    padding: 20,
    borderRadius: 5,
  },
  uploadingTitle: {
    fontFamily: 'PlayfairDisplay',
    fontSize: 26,
    letterSpacing: 0,
    textAlign: 'center',
    color: colors.secondaryTitleColor,
  },
}));

const LoadingModal = ({ title }) => {
  const classes = useStyles();

  return (
    <SimpleModal className={classes.uploadingModal} isModalOpen hideCloseIcon>
      <div className={classes.uploadingTitle}>{title}</div>
      <FbCircularProgress />
    </SimpleModal>
  );
};

LoadingModal.propTypes = {
  title: PropTypes.string,
};

export default LoadingModal;
